export default "__VITE_ASSET__CG1l9lEK__"